
import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { SasFormControlBase } from '../sas-forms/sas-form-control.base';

@Component({
    selector: 'sas-checkbox',
    standalone: true,
    imports: [TranslateModule, FormsModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SasCheckboxComponent),
            multi: true
        }
    ],
    templateUrl: './sas-checkbox.component.html',
    styleUrl: './sas-checkbox.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SasCheckboxComponent extends SasFormControlBase implements ControlValueAccessor, OnInit {
    @Input() sasDisabled: boolean = false;
    @Input() trueValue: unknown = true;
    @Input() falseValue: unknown = false;
    @Output() sasOnChange = new EventEmitter<any>();

    get isChecked(): boolean {
        return this.value === this.trueValue;
    }

    action(ev: Event): void {
        const checked = (ev.target as HTMLInputElement).checked;
        const next = checked ? this.trueValue : this.falseValue;
        this.onValueChange(next);
        this.sasOnChange.emit({ value: next });
    }
}
